export const SubscriptionOverview = {
  request_id: "RT1676269015134951",
  error_code: 0,
  error_msg: "",
  data: {
    property_count: 53, //当前房间个数
    operator: {
      name: "Hostex",
    },
    payment_methods_count: 4,
    current_plan: {
      //当前合约
      id: 460,
      edition: 1, // 合约类型：0:trail / 2:pro / 1:free(4.0.0废弃) /
      // 3:enterprice(4.0.0废弃)
      quantity: 12,
      start_date: "2023-02-01",
      expire_date: "2024-02-01",
      rest_days: 353, // 剩余天数
      period_days: 366, // 当前合约全部天数。可用于展示试用版天数
      is_expired: true, // 是否已过期
      period: 1, // 合约周期: 1/12
    },
    next_plan: {
      // 下一个合约
      id: 514,
      edition: 2,
      quantity: 200,
      create_date: "2023-03-02",
      start_date: "2023-03-02",
      expire_date: "2024-03-01",
      rest_days: 382,
      period_days: 366,
      is_expired: false,
      period: 1,
    },
    next_charge: {
      // 下一个支付
      quantity: 200,
      period: 1,
      currency_type: "USD",
      monthly_price: 5.3,
      total_price: 1058.8,
      expression: {
        //表达式
        basic: "$5.3 * 500 - 1.2", //基础价格
        promotion: "10% off", //优惠
        total: "$2384.8", //总价
        demo: "$5.3 * 500 - 1.2 - (10% off) = $2384.8", //示例
      },
      start_date: "2024-02-02",
      expire_date: "2024-03-01",
      charge_date: "2024-02-01",
    },
  },
};
